import { IDropdown } from '@app/shared/interfaces/dropdown';

export enum BOOL {
  'No, I don’t' = 1,
  'Yes, I do' = 2,
}

export const BOOL_DROPDOWN: IDropdown<string>[] = Object.values(BOOL)
  .filter((value) => isNaN(Number(value)) === true)
  .map((value) => ({ value: `${BOOL[value]}`, label: value } as IDropdown<string>));
